<script setup lang="ts">
import type { NavItem } from '~/composables/useNavigation';
import { cartItemCount } from '~/composables/useCart';

const { navItems } = useNavigation();

const emit = defineEmits(['linkClicked']);
const props = defineProps({
  sideNavOpen: Boolean,
  sideNavHalfOpen: Boolean,
});

const toggleSub = (link: NavItem) => {
  link.childrenOpen!.value = !link.childrenOpen!.value;
  // const opening = !link.childrenOpen!.value;
  // navItems.value.forEach((item) => {
  //   if (item.childrenOpen) item.childrenOpen.value = false;
  // });
  // if (opening) link.childrenOpen!.value = true;
};

const clickLink = (link: NavItem) => {
  if (!link.to) return;
  emit('linkClicked', link);
};
</script>
<template>
  <ul>
    <li v-for="(link, k) in navItems" :key="k" class="px-1 whitespace-nowrap">
      <UButton
        v-if="link.to"
        :to="link.to"
        :icon="link.icon"
        :padded="false"
        variant="ghost"
        class="w-full text-neutral hover:text-highlighted dark:hover:bg-gray-700 hover:bg-gray-200 p-1.5"
        color="neutral"
        :class="{
          'bg-gray-200 dark:bg-gray-900 text-primary': link.to && $route.path === link.to,
        }"
        @click="clickLink(link)"
      >
        <template #leading>
          <UChip v-if="link.badge && link.badge > 0" :text="cartItemCount" :label="link.badge" size="2xl" variant="solid">
            <UIcon :name="link.icon" class="text-xl" />
          </UChip>
          <UIcon v-else :name="link.icon" class="text-xl" />
        </template>
        <template v-if="props.sideNavOpen" #default>{{ $t(link.label) }}</template>
      </UButton>
      <UButton
        v-if="link.children"
        :padded="false"
        :icon="link.icon"
        variant="ghost"
        class="w-full text-neutral p-1.5"
        :class="{
          'text-primary': link.children.find((l) => l.to === $route.path),
        }"
        color="neutral"
        @click="toggleSub(link)"
      >
        <template #trailing>
          <UIcon
            v-if="link.children && props.sideNavOpen"
            :name="link.childrenOpen ? 'heroicons:chevron-down' : 'heroicons:chevron-right'"
            class="ml-auto"
          />
        </template>
        <template v-if="props.sideNavOpen" #default>{{ $t(link.label) }}</template>
      </UButton>
      <br />
      <Transition name="slide">
        <ul v-if="link.children && link.childrenOpen!.value && props.sideNavOpen" class="ml-4">
          <li v-for="(childLink, ck) in link.children" :key="ck" class="px-1 whitespace-nowrap">
            <UButton
              :to="childLink.to || undefined"
              :padded="false"
              :icon="childLink.icon"
              :label="childLink.label"
              variant="ghost"
              class="w-full text-neutral dark:hover:bg-gray-700 hover:bg-gray-200 p-1.5 text-nowrap"
              :class="{
                'text-primary bg-gray-200 dark:bg-gray-900': $route.path === childLink.to,
              }"
              color="neutral"
              @click="clickLink(childLink)"
            >
              <template #default>{{ $t(childLink.label) }}</template>
            </UButton>
          </li>
        </ul>
      </Transition>
    </li>
  </ul>
</template>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition:
    max-height 0.25s ease,
    opacity 0.25s ease;
  overflow: hidden;
  max-height: 500px;
}

.slide-enter-from,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
